import { Injectable, EventEmitter, Output, Directive } from "@angular/core";

@Injectable({
	providedIn: "root"
})

export class NavbarToggleService {
	navbarShow = false;

	@Output() change: EventEmitter<boolean> = new EventEmitter();

	toggle() {
		this.navbarShow = !this.navbarShow;
		this.change.emit(this.navbarShow);
	}

	close() {
		this.navbarShow = false;
		this.change.emit(this.navbarShow);
	}

	open() {
		this.navbarShow = true;
		this.change.emit(this.navbarShow);
	}
}
